module.exports = __webpack_public_path__ + "img/diamond-turn-right.181fb5f1.svg";